import type { ReactNode } from "react";
import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Form } from "@circle-react-shared/uikit/Form";
import { FieldWithCounter } from "../../Properties/Fields/FieldWithCounter";

interface CalloutTextFieldProps {
  formClassName: string;
  label: string | ReactNode;
  name: string;
  translationRoot: string;
}

const CALLOUT_TEXT_MAX_LENGTH = 30;

export const CalloutTextField = ({
  name,
  translationRoot,
  formClassName,
  label,
}: CalloutTextFieldProps) => (
  <FieldWithCounter
    name={name}
    label={
      <TippyV2 content={label}>
        <span className="text-default block max-w-[13rem] truncate font-normal">
          {label}
        </span>
      </TippyV2>
    }
    labelClassName="!font-normal"
    maxLength={CALLOUT_TEXT_MAX_LENGTH}
    errorMessage={t([translationRoot, "errors.callout_text_max_length"])}
  >
    <Form.Item
      className={formClassName}
      name={name}
      translationRoot={translationRoot}
      hideLabel
      hidePlaceholder
      hideBorder
      hideDescription
      rules={{
        maxLength: {
          value: CALLOUT_TEXT_MAX_LENGTH,
          message: t([translationRoot, "errors.callout_text_max_length"]),
        },
      }}
      variant="extra-bottom-margin"
    >
      <Form.Input data-testid="price_callout-callout_text-input" />
    </Form.Item>
  </FieldWithCounter>
);
